import api from "../api/api";

// GET /orders and GET /orders/{id} — confirmed real. For a "customer"
// role, the backend itself scopes the list/detail to
// Order.created_by_user_id == current_user.id (enforced server-side, not
// trusted from the frontend) — so no client-side filtering is needed or
// should be added here.
export async function getMyOrders({ page = 1, limit = 20 } = {}) {
  const res = await api.get("/orders", { params: { page, limit } });
  return res.data; // { items, total, page, limit, total_pages }
}

export async function getOrder(orderId) {
  const res = await api.get(`/orders/${orderId}`);
  return res.data; // OrderOut — backend 403s if this isn't the caller's own order
}
